module.exports = __webpack_public_path__ + "static/media/Partner9.e8b03ca1.webp";